import { IMAGE_BASE_PATH } from "@/config/config";
import cns from "classnames";
import Image from "next/image";
import { bool, node, string } from "prop-types";
import { memo } from "react";

import { inputLabel, overlayContent, overlayItem } from "./Label.module.scss";

function Label({ htmlFor, className, children, requiredField, info, ...rest }) {
  return (
    <label
      className={cns(className, inputLabel, "font-16 font-sm-13")}
      htmlFor={htmlFor}
      {...rest}
    >
      {children}
      {requiredField ? <span>*</span> : null}
      {info ? (
        <div className={cns(overlayItem)}>
          <div className={overlayContent}>
            <article>{info}</article>
          </div>

          <Image
            alt="Info Icon"
            src={`${IMAGE_BASE_PATH}/images/infoIcon.svg`}
            width={16}
            height={19}
          />
        </div>
      ) : null}
    </label>
  );
}

Label.propTypes = {
  htmlFor: string.isRequired,
  className: string,
  children: node.isRequired,
  requiredField: bool,
  info: string,
};

Label.defaultProps = {
  className: "",
  info: "",
  requiredField: false,
};

export default memo(Label);
